import React from "react";
import { CheckCircle2 } from "lucide-react";
import formatValue from "../../../utils/formatValue";
import { IFinancingInsight } from "../types/ownerDashboard.types";
import { formatAmortizationSystemLabel } from "../utils/formatAmortizationSystem";
import { formatMilestoneDate } from "../utils/formatMilestoneDate";
import { formatPropertyReturnDate } from "../utils/formatPropertyReturnDate";
import { getFinancingProgressPct } from "../utils/getFinancingProgressPct";
import FinancingCoverageBar from "./FinancingCoverageBar";

interface FinancingCompactCardProps {
  insight: IFinancingInsight;
  propertyLabel: string;
  isSelected?: boolean;
  onSelect: () => void;
}

export default function FinancingCompactCard({
  insight,
  propertyLabel,
  isSelected = false,
  onSelect,
}: FinancingCompactCardProps) {
  const progressPct = getFinancingProgressPct(insight);

  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex min-w-0 cursor-pointer flex-col gap-2 rounded-2xl border bg-[#1c2128] p-2.5 text-left transition-colors hover:border-[#6ea8ff]/35 hover:bg-[#1c2128]/90 ${
        isSelected
          ? "border-[#6ea8ff]/40 ring-1 ring-[#6ea8ff]/25"
          : "border-white/[0.08]"
      }`}
    >
      <p className="line-clamp-2 text-[0.6rem] font-semibold text-[#8b949e]">
        {propertyLabel}
      </p>
      <p className="truncate text-[0.6rem] text-[#6e7681]">
        {formatAmortizationSystemLabel(insight.amortization_system)}
        {insight.payment_start_date
          ? ` · ${formatPropertyReturnDate(insight.payment_start_date)}`
          : ""}
      </p>

      <FinancingCoverageBar
        coveragePct={progressPct}
        coversInstallment={insight.covers_installment}
        compact
      />

      {insight.covers_installment && (
        <div className="flex items-center gap-1.5 text-[#3fb950]">
          <CheckCircle2 className="h-3 w-3 shrink-0" />
          <span className="text-[0.65rem] font-semibold">Cobertura integral</span>
        </div>
      )}

      <p className="truncate text-[0.6rem] text-[#6e7681]">
        {formatValue(insight.average_monthly_net_rent)} / {formatValue(insight.monthly_installment)}
      </p>

      {!insight.covers_installment && insight.estimated_milestone_date && (
        <p className="truncate text-[0.6rem] font-medium text-[#6ea8ff]">
          Marco: {formatMilestoneDate(insight.estimated_milestone_date)}
        </p>
      )}
    </button>
  );
}
